/** Term picker for the cross-class views. Opens on the term you are teaching. */
import { Label } from '~/components/ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '~/components/ui/select';
import { ALL_TERMS, type TermOption } from './teachingTerms';

interface TermFilterProps {
  terms: readonly TermOption[];
  value: string;
  onChange: (termId: string) => void;
  currentTermId: string | null;
}

function TermFilter({ terms, value, onChange, currentTermId }: TermFilterProps) {
  if (terms.length <= 1) return null;

  return (
    <div className="flex items-center gap-2">
      <Label htmlFor="teaching-term-filter" className="text-sm text-muted-foreground">
        Term
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id="teaching-term-filter" className="w-[200px]">
          <SelectValue placeholder="Select term" />
        </SelectTrigger>
        <SelectContent>
          {terms.map((term) => (
            <SelectItem key={term.id} value={term.id}>
              {term.name}{term.id === currentTermId ? ' (current)' : ''}
            </SelectItem>
          ))}
          <SelectItem value={ALL_TERMS}>All terms</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}

export default TermFilter;
